import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Box, Typography, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, TextField, Button,
    Checkbox, Slide
} from '@mui/material';
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import Calendar from 'react-calendar';
import useStyles from './useStyles';
import db from '../firebaseConfig';

const Attham = () => {
    const history = useHistory()
    const classes = useStyles();
    const [value, setValue] = useState(new Date());
    const [open, setOpen] = useState(false);
    const [disableDates, setdisableDates] = useState([]);
    const [removeDisableTilefeature, setremoveDisableTilefeature] = useState(false)
    const alwaysdisabldates = ['14/12/2021', '15/12/2021', '17/12/2021', '18/12/2021', '20/12/2021', '21/12/2021', '23/12/2021', '24/12/2021', '26/12/2021', '27/12/2021', '29/12/2021', '30/12/2021', '1/1/2022', '2/1/2022', '4/1/2022', '5/1/2022', '7/1/2022', '8/1/2022', '10/1/2022', '11/1/2022', '13/1/2022', '14/1/2022', '16/1/2022', '17/1/2022', '19/1/2022', '20/1/2022', '22/1/2022', '23/1/2022', '25/1/2022', '26/1/2022', '28/1/2022', '29/1/2022', '31/1/2022', '1/2/2022', '3/2/2022', '4/2/2022', '6/2/2022', '7/2/2022', '9/2/2022', '10/2/2022', '12/2/2022', '13/2/2022', '15/2/2022', '16/2/2022', '18/2/2022', '19/2/2022', '21/2/2022', '22/2/2022', '24/2/2022', '25/2/2022', '27/2/2022', '28/2/2022', '2/3/2022', '3/3/2022', '5/3/2022', '6/3/2022', '8/3/2022', '9/3/2022', '11/3/2022', '12/3/2022', '14/3/2022', '15/3/2022', '17/3/2022', '18/3/2022', '20/3/2022', '21/3/2022', '23/3/2022', '24/3/2022', '26/3/2022', '27/3/2022', '29/3/2022', '30/3/2022', '1/4/2022', '2/4/2022', '4/4/2022', '5/4/2022', '7/4/2022', '8/4/2022', '10/4/2022', '11/4/2022', '13/4/2022', '14/4/2022', '16/4/2022', '17/4/2022', '19/4/2022', '20/4/2022', '22/4/2022', '23/4/2022', '25/4/2022', '26/4/2022', '28/4/2022', '29/4/2022', '1/5/2022', '2/5/2022', '4/5/2022', '5/5/2022', '7/5/2022', '8/5/2022', '10/5/2022', '11/5/2022', '13/5/2022', '14/5/2022', '16/5/2022', '17/5/2022', '19/5/2022', '20/5/2022', '22/5/2022', '23/5/2022', '25/5/2022', '26/5/2022', '28/5/2022', '29/5/2022', '31/5/2022', '1/6/2022', '3/6/2022', '4/6/2022', '6/6/2022', '7/6/2022', '9/6/2022', '10/6/2022', '12/6/2022', '13/6/2022', '15/6/2022', '16/6/2022', '18/6/2022', '19/6/2022', '21/6/2022', '22/6/2022', '24/6/2022', '25/6/2022', '27/6/2022', '28/6/2022', '30/6/2022', '1/7/2022', '3/7/2022', '4/7/2022', '6/7/2022', '7/7/2022', '9/7/2022', '10/7/2022', '12/7/2022', '13/7/2022', '15/7/2022', '16/7/2022', '18/7/2022', '19/7/2022', '21/7/2022', '22/7/2022', '24/7/2022', '25/7/2022', '27/7/2022', '28/7/2022', '30/7/2022', '31/7/2022', '2/8/2022', '3/8/2022', '5/8/2022', '6/8/2022', '8/8/2022', '9/8/2022', '11/8/2022', '12/8/2022', '14/8/2022', '15/8/2022', '17/8/2022', '18/8/2022', '20/8/2022', '21/8/2022', '23/8/2022', '24/8/2022', '26/8/2022', '27/8/2022', '29/8/2022', '30/8/2022', '1/9/2022', '2/9/2022', '4/9/2022', '5/9/2022', '7/9/2022', '8/9/2022', '10/9/2022', '11/9/2022', '13/9/2022', '14/9/2022', '16/9/2022', '17/9/2022', '19/9/2022', '20/9/2022', '22/9/2022', '23/9/2022', '25/9/2022', '26/9/2022', '28/9/2022', '29/9/2022', '1/10/2022', '2/10/2022', '4/10/2022', '5/10/2022', '7/10/2022', '8/10/2022', '10/10/2022', '11/10/2022', '13/10/2022', '14/10/2022', '16/10/2022', '17/10/2022', '19/10/2022', '20/10/2022', '22/10/2022', '23/10/2022', '25/10/2022', '26/10/2022', '28/10/2022', '29/10/2022', '31/10/2022', '1/11/2022', '3/11/2022', '4/11/2022', '6/11/2022', '7/11/2022', '9/11/2022', '10/11/2022', '12/11/2022', '13/11/2022', '15/11/2022', '16/11/2022', '18/11/2022', '19/11/2022', '21/11/2022', '22/11/2022', '24/11/2022', '25/11/2022', '27/11/2022', '28/11/2022', '30/11/2022', '1/12/2022']
    const [opensuccess, setopensuccess] = useState(false)
    const [date, SetDate] = useState("")

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });


    const getDates = async () => {
        await db.collection('attham').get()
            .then((result) => {
                if (result.docs.length > 117) {
                    setremoveDisableTilefeature(true)
                }
                var dates = [];
                result.docs.forEach((element) => {
                    var date = element.id.split('-')[0]
                    var month = element.id.split('-')[1]
                    var year = element.id.split('-')[2]
                    dates.push(new Date(`${year}-${month}-${date}`))
                })
                setdisableDates([...dates])
            }).catch(() => {
                toast.error(`Error! please Try again Later `, {
                    position: toast.POSITION.TOP_CENTER
                })
            });
    }

    useEffect(() => {
        getDates()
    }, []);

    const handleClose = (data) => {
        setOpen(false);
    };

    const handleSuccess = () => {
        setopensuccess(false)
        history.push('/')
    }

    const onClickDay = (nextValue) => {
        setValue(nextValue);
        setOpen(true);
    }

    const isDateInArray = (array, value) => {
        return array.find(item => {
            return `${item.getDate()}-${item.getMonth() + 1}-${item.getFullYear()}` === `${value.getDate()}-${value.getMonth() + 1}-${value.getFullYear()}`
        })
    }

    const isDateInDisable = (array, value) => {
        return array.find(item => {
            const result = item === `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`
            return result
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (removeDisableTilefeature) {
            let data = {
                name: event.target.name.value,
                whatsapp: event.target.whatsapp.value,
                location: event.target.location.value,
                email: event.target.email.value,
                day: `${value.getDate()}-${value.getMonth() + 1}-${value.getFullYear()}`,
            }
            db.collection('AtthamOther').add(data).then(async (results) => {
                SetDate(data.day)
                setOpen(false)
                await getDates()
                setopensuccess(true)
            }).catch((err) => {
                toast.error(`Error! please Try again Later `, {
                    position: toast.POSITION.TOP_CENTER
                })
            })
        } else {
            let email = event.target.email.value;
            let user_data = {
                [email]: [{
                    name: event.target.name.value,
                    whatsapp: event.target.whatsapp.value,
                    location: event.target.location.value
                }]
            }
            let day = `${value.getDate()}-${value.getMonth() + 1}-${value.getFullYear()}`;

            const userRef = db.collection('attham').doc(`${day}`);
            userRef.get()
                .then((result) => {
                    if (result.exists) {
                        toast.error(`Attham is already confirmed  on ${day} , Please select another date.. `, {
                            position: toast.POSITION.TOP_CENTER
                        })
                        history.push('/attham')
                    } else {
                        userRef.set(user_data);
                        SetDate(day)
                        setopensuccess(true)

                    }
                }).catch(() => {
                    toast.error(`Error! Please try agaon later`, {
                        position: toast.POSITION.TOP_CENTER
                    })
                })
            await getDates()
            setOpen(false);
        }
    }

    return (
        <Box className={classes.calendarWrapper} display="flex" flexDirection="column" justifyContent="center" mt={10}>
            <Box m="auto">
                <Typography align="center" variant="h5" fontWeight="700" gutterBottom className={classes.heroText}>અઠ્ઠમ વિધિ</Typography>
                <Typography variant="body" fontWeight="700" gutterBottom className={classes.heroText}><ol><li >૧૨ ખમાસમણા</li>
                    <li>નવકારવાળી नमो जिणाणं जिअ भयाणं — ૧ માળા</li>
                    <li>વિશ્વ હિંસા મુક્ત બને — ૧ માળા</li></ol></Typography>
            </Box>

            <Box display="flex" flexDirection="row" mt={7} justifyContent="center">
                {/* <Box className="actualCalendar" display="flex" justifyContent="flex-end"> */}
                <Calendar
                    minDate={removeDisableTilefeature ? new Date() : new Date('2021-12-13')}
                    maxDate={new Date('2022-12-2')}
                    value={value}
                    onClickDay={onClickDay}
                    tileDisabled={disableDates.length > 0 && !removeDisableTilefeature ? ({ date }) => isDateInDisable(alwaysdisabldates, date) || isDateInArray(disableDates, date) : ({ date }) => isDateInDisable(alwaysdisabldates, date)}
                    tileContent={disableDates.length > 0 && !removeDisableTilefeature ? ({ date }) => isDateInArray(disableDates, date) && <p style={{ fontSize: '10px', margin: 0, padding: 0 }}>Attham Booked</p> : () => false}
                />
            </Box>

            <Typography mt={5} align="center" variant="body" fontWeight="700" gutterBottom className={classes.heroText}>"નોંધ : ફોનથી અઠ્ઠમ અને આયંબિલની સાંકળી આરાધનામાં જોડાવા સંપર્ક કરો - ૭૦૪૩૧૭૨૨૮૭"<br /></Typography>
            <br />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Register</DialogTitle>
                <form id="user-form" onSubmit={handleSubmit}>
                    <DialogContent>
                        <DialogContentText>
                            Please in the details for successfull registration!!
                        </DialogContentText>
                        <TextField autoFocus margin="dense" id="name" name="name" label="Name" type="text" fullWidth variant="standard" required />
                        <TextField margin="dense" id="email" name="email" label="Email" type="email" fullWidth variant="standard" required />
                        <TextField margin="dense" id="whatsapp" inputProps={{ inputMode: 'numeric', pattern: '[0-9]{10}' }} name="whatsapp" label="Whatsapp" type="text" pattern="[0-9]{10}" fullWidth variant="standard" required />
                        <TextField margin="dense" id="location" name="location" label="Location" type="text" fullWidth variant="standard" required />
                        <Checkbox required /><label>I pledge to take part in the Attham</label>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Register</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                open={opensuccess}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleSuccess}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Thank you for your Registration"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Your Attham is Booked Successfully on <b>{date}</b>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSuccess}>OK</Button>
                </DialogActions>
            </Dialog>
            {/* maintenance break code */}
            {/* <Dialog
                open={true}
                TransitionComponent={Transition}
                keepMounted
                // onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"We'll be back soon!"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Sorry for the inconvenience but we&rsquo;re performing some maintenance for booking Ayambil & Attham at the moment. we&rsquo;ll be back Tomorrow!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSuccess}>OK</Button>
                </DialogActions>
            </Dialog> */}
            {/* end of maintenance break code */}
        </Box>
    )
}

export default Attham;
